<template>
    <div class="reporting-table">
        <ve-table
            :table-data="data"
            :cell-style-option="cellStyleOption"
            :cellSelectionOption="cellSelectionOption"
            :row-style-option="rowStyleOption"
            :border-around="false"
            :border-x="true"
            :border-y="false"
            :sort-option="sortOption"
            class="reporting-table"
            v-bind="$attrs"
            :fixed-header="false"

        />
        <div class="reporting-table__pagination" v-if="data.length > 0">
            {{ itemsAmount }}
            <ve-pagination
                :total="totalCount"
                :page-index="page"
                :page-size="pageSize"
                @on-page-number-change="pageNumberChange"
                :layout="['prev', 'pager', 'next']"
            />
            <div class="reporting-table__page-size">
                {{ $t('OrganizationReport.show' )}}
                <TotemSelect
                    :options="options"
                    @input="pageSizeChange"
                    :value="pageSize"
                    :clearable="false"
                    class="reporting-table__page-size-select"
                    :width="70"
                />
                {{ itemsPerPage }}
            </div>
        </div>
        <div class="reporting-table__empty" v-if="data.length === 0">
            <span class="reporting-table__empty-icon icon-warning"></span>
            <span v-html="$t('OrganizationReport.empty_table')"></span>
        </div>
    </div>
</template>
<script>
    import tableHelper from 'components/user/organizationreport/tables/helpers/table-helper'

    export default {
        name: 'pagination-table',
        mixins: [ tableHelper ],
        props: {
            data: {
                type: Array
            },
            totalCount: {
                type: Number
            },
            dataType: {
                type: String
            },
            page: {
                type: Number
            }
        },
        data () {
            return {
                rowStyleOption: {
                    stripe: true
                },
                options: [10, 20, 25, 50, 100],
                pageSize: 20,
                sortOption: {
                    sortChange: (sortParams) => {
                        this.$emit('pageNumberChange', 1)
                        this.$emit('sortChange', sortParams)
                    }
                }
            }
        },
        computed: {
            usersFrom () {
                if (this.page === 1) {
                    return this.page
                }
                return this.page * this.pageSize - this.pageSize + 1
            },
            usersTo () {
                let usersTo = this.usersFrom + this.pageSize - 1
                if (this.totalCount < usersTo ) {
                    let diff = usersTo - this.totalCount
                    return usersTo - diff
                }
                return usersTo
            },
            itemsAmount () {
                return this.$t('OrganizationReport.show_items_amount', {
                    itemsFrom: this.usersFrom,
                    itemsTo: this.usersTo,
                    itemsTotal: this.totalCount,
                    itemsType: this.dataType
                })
            },
            itemsPerPage () {
                return this.$t('OrganizationReport.items_per_page', { itemsType: this.dataType })
            }
        },
        methods: {
            pageNumberChange (pageIndex) {
                this.$emit('pageNumberChange', pageIndex)
            },
            pageSizeChange (pageSize) {
                this.pageSize = pageSize
                this.$emit('pageNumberChange', 1)
                this.$emit('pageSizeChange', pageSize)
            }
        }
    }
</script>
